import React, { useEffect, useState } from "react";
import { Form, Container } from "react-bootstrap";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Withdrawl_Problem.css";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { SubmitWithdrawQuery } from "../../features/support/slice";
import { GetSingle } from "../../features/wallet/slice";
import { decodeId } from "../../utils/common";

function Withdrawl_Problem() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [orderData, setOrderData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  // ─── Files State ──────────────────────────────────────
  const [files, setFiles] = useState({
    day_3: null,
  });

  // ─── Previews State ───────────────────────────────────
  const [previews, setPreviews] = useState({
    day_3: null,
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      withdrawal_amount: "",
      pdf_password: "",
    },
  });

  // ─── Fetch Order Data ─────────────────────────────────
  const fetchOrderData = async (id) => {
    const res = await dispatch(
      GetSingle({ id: decodeId(id), type: "withdraw" })
    );
    if (res?.payload?.success) {
      setOrderData(res?.payload?.data);
      reset({
        withdrawal_amount: res?.payload?.data?.amount || "",
        pdf_password: res?.payload?.data?.pdf_password || "",
      });
    }
  };

  useEffect(() => {
    if (id) fetchOrderData(id);
  }, [id]);

  // ─── File Change Handler ──────────────────────────────
  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({ ...prev, [key]: file }));
    setPreviews((prev) => ({
      ...prev,
      [key]: file.type.startsWith("image")
        ? URL.createObjectURL(file)
        : "file_uploaded",
    }));
  };

  // ─── Upload Box ───────────────────────────────────────
  const UploadBox = ({ fieldId }) => (
    <div className="upload_box">
      <input
        type="file"
        id={fieldId}
        hidden
        accept=".pdf,.doc,.docx"
        onChange={(e) => handleFileChange(e, fieldId)}
      />
      <label htmlFor={fieldId} className="photo_label">
        {previews[fieldId] && previews[fieldId] !== "file_uploaded" ? (
          <img
            src={previews[fieldId]}
            alt="Preview"
            className="uploaded_img_preview"
          />
        ) : previews[fieldId] === "file_uploaded" ? (
          <div className="success_upload">
            <FontAwesomeIcon
              icon={faCloudUploadAlt}
              style={{ color: "#28a745" }}
            />
            <span>Uploaded</span>
          </div>
        ) : (
          <>
            <FontAwesomeIcon icon={faCloudUploadAlt} />
            <span>Upload</span>
          </>
        )}
      </label>
    </div>
  );

  // ─── Submit Handler ───────────────────────────────────
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("order_id", orderData?.id || "");
      formData.append("order_number", orderData?.order_number || orderData?.order_no || "");
      formData.append("withdrawal_amount", data.withdrawal_amount);
      formData.append("pdf_password", data.pdf_password || "");

      // ── Attach PDF if uploaded ──
      if (files.day_3) formData.append("day_3", files.day_3);

      const res = await dispatch(SubmitWithdrawQuery(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage("Withdrawal query submitted successfully");
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 2000);
      } else {
        setModalMessage(res?.payload?.errors || "Submission failed. Please try again");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }

    } catch (error) {
      console.error("Withdraw Query Submit Error:", error);
    }
  };

  return (
    <>
      <section className="Modify_Bank_Information Deposit_Not_Received_Form">
        <Common_white_header headingText={"Withdrawal Problem"} />
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* ── Order Number (read only from API) ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Order Number <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                disabled
                value={orderData?.order_number || orderData?.order_no || ""}
              />
            </Form.Group>

            {/* ── Withdrawal Amount ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Withdrawal Amount <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter withdrawal amount"
                {...register("withdrawal_amount", {
                  required: "Withdrawal amount is required",
                  min: { value: 1, message: "Amount must be greater than 0" },
                })}
              />
              {errors.withdrawal_amount && (
                <small className="text-danger">
                  {errors.withdrawal_amount.message}
                </small>
              )}
            </Form.Group>

            {/* ── PDF Password ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Provide PDF Password <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter PDF Password"
                {...register("pdf_password", {
                  required: "PDF Password is required",
                })}
              />
              {errors.pdf_password && (
                <small className="text-danger">
                  {errors.pdf_password.message}
                </small>
              )}
            </Form.Group>

            {/* ── PDF Upload ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                More than 3 days not received — Attach PDF bank statement
              </Form.Label>
              <UploadBox fieldId="day_3" />
            </Form.Group>

            {/* ── Note ── */}
            <div className="note_div">
              <p className="sub_text">
                If withdrawal was not received for more than 72 hours, download
                your PDF bank statement and submit it in the self-service center.
              </p>
            </div>

            {/* ── Submit ── */}
            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </Container>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Withdrawl_Problem;